export default __webpack_public_path__ + "content/c0285e5e9ebdce9056be2d07d5e0f7be.svg";